{
  "level": "field6",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:field6",
    "objects": "AREAS.E3:field6.e3",
    "mesh": "TREES.E3:field6.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4370.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: field6",
      "entity_class": "CSlidingDoor",
      "piece_name": "field6",
      "offset": 437,
      "centroid": [
        1596.25,
        1070.0,
        134.8333339691162
      ],
      "bbox_min": [
        1380.0,
        1070.0,
        93.33333587646484
      ],
      "bbox_max": [
        1690.0,
        1070.0,
        180.0
      ],
      "dimensions_source": {
        "span_x": 310.0,
        "span_y": 0.0,
        "height_z": 86.66666412353516,
        "door_width": 310.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x"
      },
      "vertices": [
        [
          1380.0,
          1070.0,
          180.0
        ],
        [
          1690.0,
          1070.0,
          180.0
        ],
        [
          1690.0,
          1070.0,
          112.0
        ],
        [
          1680.0,
          1070.0,
          93.33333587646484
        ],
        [
          1630.0,
          1070.0,
          93.33333587646484
        ],
        [
          1630.0,
          1070.0,
          140.0
        ],
        [
          1380.0,
          1070.0,
          140.0
        ],
        [
          1690.0,
          1070.0,
          140.0
        ]
      ]
    }
  ],
  "tutorial_messages": []
}